import { HStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const PriceAndCaloriesWrapper = HStack.withConfig({
  width: 'full',
  flexDirection: 'row',
  marginTop: 0,
  marginBottom: 3,
  space: '$2',
  alignItems: 'center',
  _web: { justifyContent: 'center' },
});

export const PriceCaloriesText = withTypography({ fontSize: 'lg' });
